// extracted by mini-css-extract-plugin
export default {"container":"product-promotions__container___291Pv","promo":"product-promotions__promo___2S2g3"};